<template>
    <header class="main-header">
        <!-- Logo -->
        <a href="#" class="logo">
            <!-- mini logo for sidebar mini 50x50 pixels -->
            <span class="logo-mini"><b>{{ branding.nameMiniParts.bold }}</b>{{ branding.nameMiniParts.light }}</span>
            <!-- logo for regular state and mobile devices -->
            <span class="logo-lg"><b>{{ branding.nameBold }}</b>{{ branding.nameLight }}</span>
        </a>
        <!-- Header Navbar: style can be found in header.less -->
        <nav class="navbar navbar-static-top">
            <!-- Sidebar toggle button-->
            <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
                <span class="sr-only">Abilita la navigazione</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </a>

            <div class="navbar-custom-menu">
                <ul class="nav navbar-nav">
                    <!-- User Account: style can be found in dropdown.less -->
                    <li class="dropdown user user-menu">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <span class="">{{ profile.name }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <!-- User image -->
                            <li class="user-header">
                                <p>
                                    {{ profile.name }} - {{ profile.email }}
                                    <small>Registrato il {{ profile.created_at | dateFormatBase }}</small>
                                </p>
                                <p v-if="profile.entity">
                                    Ente: <strong>{{ profile.entity.data.name }}</strong>
                                </p>
                                <p v-if="profile.archive">
                                    Archivio: <strong>{{ profile.archive.data.nome }}</strong>
                                </p>
                            </li>

                            <!-- Menu Footer-->
                            <li class="user-footer">
                                <div class="pull-left" v-if="$accessControl.isOperator($store.state.profile.profile)">
                                    <router-link :to="{ name: 'profile'}" class="btn btn-default btn-flat">Profilo
                                    </router-link>
                                </div>
                                <div class="pull-right">
                                    <router-link :to="{ name: 'logout'}" class="btn btn-default btn-flat">Logout
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
  export default {
    name: 'topbar',
    computed: {
      profile () {
        return this.$store.state.profile.profile
      },
      branding () {
        return this.$store.state.branding.current
      }
    }
  }
</script>

<style>
    .navbar-nav > .user-menu > .dropdown-menu > li.user-header {
        height: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/TopBar.vue